import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";

export const useIsUserVerified = () => {
  const { data, isLoading } = useVerificationsQuery();

  const verificationLevel = data?.verificationLevel ?? 0;
  const isUserVerified = verificationLevel > 1;

  return { isUserVerified, isLoading };
};
